export enum sortType {
    ASC = 'asc',
    DESC = 'desc',
}
